import React from "react";
import { Link } from "react-router-dom";
import { getTypes } from "../../api/budget";

export default class Drawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { status: "open" };
  }

  async loadTypeInfo() {
    const types = await getTypes();
    this.typeList = types;
  }

  toggleDrawer = () => {
    if (this.state.status === "close") this.setState({ status: "open" });
    else this.setState({ status: "close" });
  };

  render() {
    return (
      <nav className="drawer">
        <div>
          <button onClick={this.toggleDrawer}>toggle</button>
        </div>
        <div>
          <Link to="/login">
            <button>Login</button>
          </Link>
        </div>
        <ul>
          <Link to="/">
            <li>{this.state.status === "close" ? "H" : "Home"}</li>
          </Link>
          <Link to="/budget">
            <li>{this.state.status === "close" ? "B" : "Budget"}</li>
          </Link>
          <Link to="/account-book">
            <li>{this.state.status === "close" ? "A" : "AccountBook"}</li>
          </Link>
          <Link to="/routine">
            <li>{this.state.status === "close" ? "R" : "Routine"}</li>
          </Link>
          {/* <Link to="/todo">
            <li>{this.state.status === "close" ? "T" : "Todo"}</li>
          </Link> */}
          <Link to="/youtube">
            <li>{this.state.status === "close" ? "Y" : "Youtube"}</li>
          </Link>
        </ul>
      </nav>
    );
  }
}
